export default __webpack_public_path__ + "static/Plots0042-b3f19bb97cfc011e0a7caca3598cd358.jpg";